import { getDocs, query, where, collection, orderBy } from 'firebase/firestore';
import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { db } from '../../firebase';
import { Button } from "@material-tailwind/react";
import { Link } from "react-router-dom";

const PoomDataDetail = () => {
  const { id } = useParams();
  const location = useLocation();
  const { uid } = location.state;
  const { poomProductName } = location.state;
  const [dataDetail, setDataDetail] = useState([]);
  const [chatRoomHistory, setChatRoomHistory] = useState([]);

  useEffect(() => {
    const getPoomDataDetail = async () => {
      const chatRoomCol = query(
        collection(db, "chatrooms"),
        where("isPoom", "==", true),
        where("pid", "==", id),
        orderBy('mostCurrentMsgTime', 'desc')
      );
      const userCol = query(collection(db, "users"), where("uid", "==", uid));
      const poomProductDetail = await getDocs(userCol);
      const chatRoomPresent = await getDocs(chatRoomCol);
      try {
        setDataDetail(
          poomProductDetail.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }))
        );
        setChatRoomHistory(
          chatRoomPresent.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id
          }))
        );
      } catch (error) {
        console.log(error);
      }
    };
    getPoomDataDetail();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="max-w-[700px] mx-auto my-6 p-4">
      {dataDetail.map((data) => {
        return (
          <>
            <div>
              <h2 className="text-2xl font-bold py-2">
                Pastry: {poomProductName}
              </h2>
              <h2>Baker's Name: {data.fullName}</h2>
              <h2>Email: {data.email}</h2>
            </div>
          </>
        );
      })}
      <div className='grid grid-cols-4 gap-4 pt-4'>
        {chatRoomHistory.map((data, index) => {
          return (
            <Link
              to={`/chatroom/${data.id}`}
              state={{ chatRoomid: `${data.id}` }}
            >
              <Button
                variant="outlined"
                size="md"
                color="orange"
                className="mt-2"
              >
                Chatroom {index + 1}
              </Button>
            </Link>
          );
        })}
      </div>
    </div>
  );
}

export default PoomDataDetail;
